import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PnBaseDialog, PnDialog, PnDialogTemplate } from '@privanot/shared-ui/primeng-acl/dialog';
import { PnProgressSpinner } from '@privanot/shared-ui/primeng-acl/progress-spinner';
import { PnButton } from '@privanot/shared-ui/primeng-acl/button';
import { PnIcon } from '@privanot/shared-ui/common/icon';

@Component({
    selector: 'app-connectivity-modal',
    imports: [PnDialog, PnDialogTemplate, PnProgressSpinner, PnButton, PnIcon, TranslatePipe],
    templateUrl: './connectivity-modal.html',
    styleUrl: './connectivity-modal.scss',
})
export class ConnectivityModal extends PnBaseDialog {
    public isConnecting = input(false);
    public hasError = input(false);
    public errorMessageKey = input<string>('splash.error');
    public retry = output<void>();
}
